import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { MaterialModule } from './material.module';
import { SharedModule } from './shared/shared.module';
//import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UploadsModule } from '@progress/kendo-angular-upload';
//import { ChartsModule } from '@progress/kendo-angular-charts';

import { MatGridListModule } from '@angular/material/grid-list';
import { PrintService } from './print.service';
//import { TelerikReportingModule } from '@progress/telerik-angular-report-viewer';

import { UserService } from './user.service';
import { ErrorHandlerService } from './error-handler.service';
import { CustomInterceptor } from './custom.interceptor';
import { NgxEchartsModule } from 'ngx-echarts';

import { LoginModule } from './login/login.module';
import { LayoutNewModule } from './layout/layout.module';
import { HomeModule } from './home/home.module';
import { ProductsModule } from './products/products.module';
import { SuppliersModule } from './suppliers/suppliers.module';
import { SalesModule } from './sales/sales.module';
import { FilesModule } from './files/files.module';
import { AttendanceModule } from './attendance/attendance.module';
//import { UserModule } from './user/user.module';
import { RouterModule,Routes } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    //AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    SharedModule,
    GridModule,
    DropDownsModule,
    ButtonsModule,
    DateInputsModule,
    LayoutModule,
    PDFExportModule,
    ExcelExportModule,
    DialogsModule,
    UploadsModule,
    LoginModule,
    LayoutNewModule,
    HomeModule,
    ProductsModule,
    SuppliersModule,
    SalesModule,
    FilesModule,
    AttendanceModule,
    //UserModule,
    MatGridListModule,
    //TelerikReportingModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    RouterModule.forRoot(routes),
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    //ChartsModule,
  ],
  providers: [
    NgxSpinnerService,
    DatePipe,
    PrintService,
    UserService,
    {
      provide: ErrorHandler,
      useClass: ErrorHandlerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
